import { useNavigate } from 'react-router-dom'
import { links } from '~/AppRoutes'
import { GenericCancelDialog } from '~/common/components'

type Props = {
  open: boolean
  onCancel: () => void
}

export const CancelDialog = ({ open, onCancel }: Props) => {
  const navigate = useNavigate()
  return <GenericCancelDialog open={open} onAccept={() => navigate(links.returnHubsLink())} onReject={onCancel} />
}
